// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-title-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 440px !important;
  max-width: calc(100vw - 24px);
}

.job-title-drawer .ant-drawer-header {
  display: none;
}

.job-title-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.job-title-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.job-title-drawer__header {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.job-title-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  min-width: 0;
}

.job-title-drawer__dot {
  width: 8px;
  height: 8px;
  margin-top: 8px;
  border-radius: 9999px;
  background: #0ea5e9;
  flex-shrink: 0;
}

.job-title-drawer__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.015em;
  color: #0f172a;
  line-height: 24px;
}

.job-title-drawer__subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #64748b;
}

.job-title-drawer__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  flex-shrink: 0;
}

.job-title-drawer__close:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.job-title-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
}

.job-title-drawer__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #0f172a;
}

.job-title-drawer__req {
  color: #ba1a1a;
}

.job-title-drawer__input.ant-input,
.job-title-drawer__input.ant-input-number,
.job-title-drawer__select.ant-select-single .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border: 1px solid #e2e8f0;
  background: #ffffff !important;
  box-shadow: none !important;
  font-size: 13px !important;
}

.job-title-drawer__input.ant-input {
  padding: 0 12px;
  color: #0f172a;
}

.job-title-drawer__input.ant-input-number {
  width: 100%;
  padding: 0;
}

.job-title-drawer__input.ant-input-number .ant-input-number-input {
  height: 34px;
  padding: 0 12px;
  font-size: 13px;
  color: #0f172a;
}

.job-title-drawer__input.ant-input::placeholder,
.job-title-drawer__input.ant-input-number-input::placeholder,
.job-title-drawer__select .ant-select-selection-placeholder {
  color: #94a3b8;
}

.job-title-drawer__select.ant-select {
  width: 100%;
}

.job-title-drawer__select.ant-select-single .ant-select-selection-item,
.job-title-drawer__select.ant-select-single .ant-select-selection-placeholder {
  line-height: 34px !important;
  font-size: 13px !important;
}

.job-title-drawer__input.ant-input:focus,
.job-title-drawer__input.ant-input-number-focused,
.job-title-drawer__select.ant-select-focused .ant-select-selector {
  border-color: #0ea5e9 !important;
  box-shadow: 0 0 0 1px #0ea5e9 !important;
}

.job-title-drawer__hint {
  margin: 0;
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.job-title-drawer__note {
  margin: 0;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 11px;
  line-height: 1.55;
  color: #64748b;
}

.job-title-drawer__note strong {
  font-weight: 600;
  color: #0f172a;
}

.job-title-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.job-title-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
}

.job-title-drawer__btn--ghost {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  font-weight: 500;
}

.job-title-drawer__btn--ghost:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.job-title-drawer__btn--primary {
  border: 0;
  background: #0ea5e9;
  color: #ffffff;
  font-weight: 600;
}

.job-title-drawer__btn--primary:hover:not(:disabled) {
  background: #0284c7;
}

.job-title-drawer__btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.job-title-drawer .ant-form-item {
  margin-bottom: 0 !important;
}

.job-title-drawer .ant-form-item-label {
  padding: 0 0 6px !important;
}

.job-title-drawer .ant-form-item-label > label {
  height: auto;
}

.job-title-drawer .ant-form-item-extra {
  margin-top: 6px;
  min-height: 0;
}

.job-title-drawer .ant-form-item-explain-error {
  font-size: 11px;
  margin-top: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Settings/drawers/AddJobTitleDrawer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,uBAAuB;EACvB,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;;;EAGE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB","sourcesContent":[".job-title-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 440px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.job-title-drawer .ant-drawer-header {\n  display: none;\n}\n\n.job-title-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.job-title-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.job-title-drawer__header {\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e2e8f0;\n  background: #ffffff;\n}\n\n.job-title-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  min-width: 0;\n}\n\n.job-title-drawer__dot {\n  width: 8px;\n  height: 8px;\n  margin-top: 8px;\n  border-radius: 9999px;\n  background: #0ea5e9;\n  flex-shrink: 0;\n}\n\n.job-title-drawer__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.015em;\n  color: #0f172a;\n  line-height: 24px;\n}\n\n.job-title-drawer__subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 16px;\n  color: #64748b;\n}\n\n.job-title-drawer__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  color: #94a3b8;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.job-title-drawer__close:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.job-title-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n}\n\n.job-title-drawer__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.job-title-drawer__req {\n  color: #ba1a1a;\n}\n\n.job-title-drawer__input.ant-input,\n.job-title-drawer__input.ant-input-number,\n.job-title-drawer__select.ant-select-single .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border: 1px solid #e2e8f0;\n  background: #ffffff !important;\n  box-shadow: none !important;\n  font-size: 13px !important;\n}\n\n.job-title-drawer__input.ant-input {\n  padding: 0 12px;\n  color: #0f172a;\n}\n\n.job-title-drawer__input.ant-input-number {\n  width: 100%;\n  padding: 0;\n}\n\n.job-title-drawer__input.ant-input-number .ant-input-number-input {\n  height: 34px;\n  padding: 0 12px;\n  font-size: 13px;\n  color: #0f172a;\n}\n\n.job-title-drawer__input.ant-input::placeholder,\n.job-title-drawer__input.ant-input-number-input::placeholder,\n.job-title-drawer__select .ant-select-selection-placeholder {\n  color: #94a3b8;\n}\n\n.job-title-drawer__select.ant-select {\n  width: 100%;\n}\n\n.job-title-drawer__select.ant-select-single .ant-select-selection-item,\n.job-title-drawer__select.ant-select-single .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  font-size: 13px !important;\n}\n\n.job-title-drawer__input.ant-input:focus,\n.job-title-drawer__input.ant-input-number-focused,\n.job-title-drawer__select.ant-select-focused .ant-select-selector {\n  border-color: #0ea5e9 !important;\n  box-shadow: 0 0 0 1px #0ea5e9 !important;\n}\n\n.job-title-drawer__hint {\n  margin: 0;\n  font-size: 11px;\n  line-height: 1.45;\n  color: #64748b;\n}\n\n.job-title-drawer__note {\n  margin: 0;\n  padding: 12px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 11px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n.job-title-drawer__note strong {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.job-title-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.job-title-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.job-title-drawer__btn--ghost {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #475569;\n  font-weight: 500;\n}\n\n.job-title-drawer__btn--ghost:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.job-title-drawer__btn--primary {\n  border: 0;\n  background: #0ea5e9;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.job-title-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284c7;\n}\n\n.job-title-drawer__btn--primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.job-title-drawer .ant-form-item {\n  margin-bottom: 0 !important;\n}\n\n.job-title-drawer .ant-form-item-label {\n  padding: 0 0 6px !important;\n}\n\n.job-title-drawer .ant-form-item-label > label {\n  height: auto;\n}\n\n.job-title-drawer .ant-form-item-extra {\n  margin-top: 6px;\n  min-height: 0;\n}\n\n.job-title-drawer .ant-form-item-explain-error {\n  font-size: 11px;\n  margin-top: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
